import { LANGUAGES } from '@/utils/constants'

const { PORTUGUESE, ENGLISH, SPANISH } = LANGUAGES

export const ACCEPTED_FILES = 'accepted files'
export const PLACEHOLDER_SURVEY_NAME = 'survey name'
export const LANGUAGE = 'language'
export const LANGUAGE_PORTUGUESE = 'portuguese'
export const LANGUAGE_ENGLISH = 'english'
export const LANGUAGE_SPANISH = 'spanish'
export const TYPE = 'type'
export const UPLOAD = 'type'
export const SELECT_FILE = 'select file'
export const VIEW_TEMPLATES = 'view templates'
export const CREATE_NEW = 'create new'
export const REQUIRED_FIELDS = 'required fields'

export default {
  [PORTUGUESE]: {
    [ACCEPTED_FILES]: 'Arquivos aceitos',
    [PLACEHOLDER_SURVEY_NAME]: 'Nome da Pesquisa',
    [LANGUAGE]: 'Idioma',
    [LANGUAGE_PORTUGUESE]: 'Português',
    [LANGUAGE_ENGLISH]: 'Inglês',
    [LANGUAGE_SPANISH]: 'Espanhol',
    [TYPE]: 'Tipo',
    [SELECT_FILE]: 'Selecione o Arquivo',
    [VIEW_TEMPLATES]: 'Ver Modelos',
    [CREATE_NEW]: 'Crie um Novo',
    [REQUIRED_FIELDS]: 'Por favor preencha os campos obrigatórios',
  },

  [ENGLISH]: {
    [ACCEPTED_FILES]: 'Accepted files',
    [PLACEHOLDER_SURVEY_NAME]: 'Survey Name',
    [LANGUAGE]: 'Language',
    [LANGUAGE_PORTUGUESE]: 'Portuguese',
    [LANGUAGE_ENGLISH]: 'English',
    [LANGUAGE_SPANISH]: 'Spanish',
    [TYPE]: 'Type',
    [SELECT_FILE]: 'Select File',
    [VIEW_TEMPLATES]: 'View Templates',
    [CREATE_NEW]: 'Create New',
    [REQUIRED_FIELDS]: 'Please fill in the required fields',
  },

  [SPANISH]: {
    [ACCEPTED_FILES]: 'Archivos aceptados',
    [PLACEHOLDER_SURVEY_NAME]: 'Nombre de la encuesta',
    [LANGUAGE]: 'Idioma',
    [LANGUAGE_PORTUGUESE]: 'Portugués',
    [LANGUAGE_ENGLISH]: 'Inglés',
    [LANGUAGE_SPANISH]: 'Español',
    [TYPE]: 'Tipo',
    [SELECT_FILE]: 'Seleccione Archivo',
    [VIEW_TEMPLATES]: 'Ver Modelos',
    [CREATE_NEW]: 'Crear Nuevo',
    [REQUIRED_FIELDS]: 'Por favor llene los campos requeridos',
  },
}
